import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../../common/Logo';
import FormContainer from '../../../common/sections/FormContainer';
import useThemeContext from '../../../../themes/hooks/useThemeContext';
import { Brightness7, Brightness4 } from '@mui/icons-material';

interface ResetPasswordFormProps {
     onSubmit: (email: string) => void;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ onSubmit }) => {
     const [email, setEmail] = useState('');
     const { theme, toggleTheme } = useThemeContext();

     const handleSubmit = (e: React.FormEvent) => {
          e.preventDefault();
          onSubmit(email);
     };

     const logoSrc = theme.palette.mode === 'dark' ? '/src/assets/png/logo-dark.png' : '/src/assets/png/logo-light.png';

     return (
          <FormContainer>
               <Box sx={{ alignSelf: 'center', mb: 2 }}>
                                        <IconButton
                                             onClick={toggleTheme}
                                             sx={{
                                                  position: 'absolute',
                                                  top: 16,
                                                  right: 16,
                                                  color: theme.palette.text.primary,
                                                  '&:hover': {
                                                       backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[200],
                                                  },
                                             }}
                                        >
                                             {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
                                        </IconButton>
                    <Logo
                         alt='Logo IS Eventos'
                         width={120}
                         height={120}
                         src={logoSrc}
                    />
               </Box>
               <Typography
                    variant='h5'
                    fontWeight={700}
                    align='center'
                    sx={{ mb: 1 }}
               >
                    Redefinir senha
               </Typography>
               <Typography
                    variant='body2'
                    color='text.secondary'
                    align='center'
                    sx={{ mb: 3 }}
               >
                    Informe seu e-mail para receber o link de redefinição de senha.
               </Typography>
               <form
                    onSubmit={handleSubmit}
                    style={{ width: '100%' }}
               >
                    <Stack spacing={2}>
                         <TextField
                              label='E-mail'
                              type='email'
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              fullWidth
                         />
                         <Button
                              type='submit'
                              variant='contained'
                              color='primary'
                              fullWidth
                         >
                              Enviar link de redefinição
                         </Button>
                         <Button
                              component={Link}
                              to='/login'
                              color='primary'
                         >
                              Voltar para o login
                         </Button>
                    </Stack>
               </form>
          </FormContainer>
     );
};

export default ResetPasswordForm;
